import { useState } from "react";
import { Alert, Button, DatePicker } from "antd";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { Method_POST } from "../../../../../../../service/api";

export function DataEncerramento({ info, setInfo, numeroSolicita, setIsModalDataEncerramento, fetchData }) {

    const [loading, setLoading] = useState(false);

    const onChangeDataEncerramento = (date, dateString) => {
        setInfo((prev) => ({
            ...prev,
            dataEncerramento: date
        }));
    }

    const atualizarDataEncerramento = async () => {
        setLoading(true);
        try {
            const url = `/ordem-servico/empresa/encerramento/atualizar`;
            const dataFormatada = dayjs(info.dataEncerramento).toISOString();

            const payload = {
                dataEncerramento: dataFormatada,
                id: numeroSolicita,
            };
            const response = await Method_POST(url, payload);
            if (response) {
                toast.success("Alteração feita com sucesso!");
                fetchData();
                setIsModalDataEncerramento(false);
            }

            if (!response) {
                throw new Error("Nenhum dado retornado da API");
            }

        } catch (error) {
            toast.error(error.message);
            // console.log(error.message)
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            <div style={{ padding: 10 }}>
                <Alert message="Informe a data de encerramento da empresa." />
            </div>

            <div>

                {loading ? (
                    <div>
                        <Box sx={{ display: "flex" }}>
                            <CircularProgress />
                        </Box>
                    </div>
                ) : (
                    <div>
                        <div style={{margin: 5}}>
                            <p>Data Encerramento</p>
                            <DatePicker
                                onChange={onChangeDataEncerramento}
                                value={
                                    info.dataEncerramento && info.dataEncerramento !== ""
                                        ? dayjs(info.dataEncerramento)
                                        : dayjs() // se for null ou vazio usa a data atual
                                }
                                format="DD/MM/YYYY"
                            />
                        </div>


                        <div style={{display: "flex", justifyContent: "right", alignItems: "right"}}>
                            <Button
                                type="primary"
                                className="color"
                                loading={loading}
                                onClick={atualizarDataEncerramento}
                            >
                                Salvar
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default DataEncerramento;
